import Vue from 'vue'

import { projectName } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { services } from '@/utils'

import render from './render'

const Cache = new Macro({
  ttl: 5 * 1000,
  ttlInterval: 1000
})

const cachedGet = Cache.wrapWithCache(async (key, service, id) => {
  return await Vue.$GRequest?.get(service, id, { query: { $scope: [ 'full' ] } })
})

export default {
  name: 'Fallbacks',

  props: {
    value: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      loading: false,
      items: []
    }
  },

  computed: {
    itemsWithId() {
      const items = this.value?.fallbacks || []
      if (Array.isArray(items) && items.length) {
        return items.filter(item => item?.id).map(item => item.id)
      }
    },

    itemsWithoutId() {
      const items = this.value?.fallbacks || []
      if (Array.isArray(items) && items.length) {
        return items.filter(item => !item?.id)
      }
    }
  },

  watch: {
    itemsWithId: {
      handler() {
        this.get()
      },
      deep: true
    }
  },

  mounted() {
    this.get()
  },

  methods: {
    async get() {
      try {
        this.loading = true
        if (Array.isArray(this.itemsWithId) && this.itemsWithId.length) {
          this.items = await Promise.all(this.itemsWithId.map(async id => {
            const key = [ projectName, services.sendings, 'get', id ].filter(Boolean).join(':')
            const response = await cachedGet(key, services.sendings, id)
            if (response?.data) {
              this.loading = false

              return response.data
            }
          }))
        }
      } catch (error) {
      } finally {
        this.loading = false
      }
    }
  },

  render
}
